import React from "react";
import {
  AttachMoney,
  Description,
  Inventory,
  LanguageOutlined,
  Settings,
  TextFields,
} from "@mui/icons-material";
import MultiLangForm from "../../../../../../../../components/form/MultiLangForm";
import ServiceTitleForm from "./ServiceTitleForm";
import ChipTabs from "../../../../../../../../components/ChipsTabs";
import { PRICES_BASE_REQUEST } from "../../../../../../../../enums/ApiPaths";
import { SERVICES } from "../../../../../../../../enums/QueryKeys";
import Other from "./Other";
import {
  serviceMaxDesc,
  serviceMaxTitle,
} from "../../../../../../../services/form/ServiceForm";
import ServiceResources from "./ServiceResources";
import ServicePricingForm from "./ServicePricingForm";

export default function ServiceChipsTab({ price, clinicId }) {
  const editPath = PRICES_BASE_REQUEST + clinicId;
  const icons = [
    <TextFields />,
    <LanguageOutlined />,
    <Description />,
    <Inventory />,
    <AttachMoney />,
    <Settings />,
  ];
  const tabContent = [
    <MultiLangForm
      key={"titleTranslation"}
      btnMsg={"Save"}
      object={price}
      maxLength={serviceMaxTitle}
      inputProps={{ maxLength: serviceMaxTitle }}
      postUrl={editPath}
      mutationKey={SERVICES + clinicId}
    />,
    <MultiLangForm
      key={"descriptionTranslation"}
      btnMsg={"Save"}
      translationTarget="descriptionTranslation"
      object={price}
      maxLength={serviceMaxDesc}
      inputProps={{ maxLength: serviceMaxDesc }}
      postUrl={editPath}
      mutationKey={SERVICES + clinicId}
    />,
    <ServiceTitleForm
      price={price}
      clinicId={clinicId}
      maxLength={serviceMaxTitle}
      inputProps={{ maxLength: serviceMaxTitle }}
    />,
    <ServiceResources price={price} clinicId={clinicId} />,
    <ServicePricingForm price={price} clinicId={clinicId} />,
    <Other price={price} clinicId={clinicId} />,
  ];
  const tabLabels = [
    "TitleTranslation",
    "DescriptionTranslation",
    "EditFallbackTitle",
    "Resources",
    "Pricing",
    "Other",
  ];
  const tabKeys = [price.id, price.id, price.id, price.id, price.id];
  return (
    <ChipTabs
      lsKey={"SERVICE_LS_KEY"}
      tabKeys={tabKeys}
      icons={icons}
      tabContent={tabContent}
      tabLabels={tabLabels}
      wrapperMaxWidth="88vw"
    />
  );
}
